// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#AnalyzePage .AppBarCustomContent,#AnalyzePage .bg-icon{align-items:center;display:flex}#AnalyzePage .bg-icon{background:#fff;border-radius:50%;height:24px;justify-content:center;width:24px}#AnalyzePage .content-item .description p{color:#616161;font-size:15px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
